
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/cards",
      function () {
        return require("private-next-pages/user/cards/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/cards"])
      });
    }
  